export default function TrustSection() {
  return (
    <section className="relative w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="flex flex-col lg:flex-row gap-14 lg:gap-20">
          <div className="flex-1 flex flex-col justify-center">
            <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500 font-medium mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              Warum wir?
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-6 leading-tight lg:max-w-lg">
              OOPBUY Spreadsheet bietet dir Trusted Sellers, QC und Shipping-Infos.
            </h2>
            <p className="text-base md:text-lg text-foreground-500 mb-8 leading-relaxed max-w-xl">
              Wir sind eine unabhängige Informationsplattform, die deutschen Nutzern hilft, sicher und informiert über OOPBUY Spreadsheet einzukaufen. Keine versteckten Gebühren, keine Fake-Bewertungen – nur ehrliche, geprüfte Informationen.
            </p>

            <div className="grid grid-cols-3 gap-6 md:gap-10">
              <div>
                <div className="text-3xl md:text-4xl font-bold text-primary-500 mb-1">14+</div>
                <div className="text-sm text-foreground-500">Kategorien</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-accent-500 mb-1">100%</div>
                <div className="text-sm text-foreground-500">Unabhängig</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-secondary-500 mb-1">DE</div>
                <div className="text-sm text-foreground-500">Deutschland Fokus</div>
              </div>
            </div>
          </div>

          <div className="flex-1 flex flex-col gap-4">
            <div className="flex gap-4">
              <div
                className="w-[45%] aspect-[4/5] rounded-2xl bg-cover bg-center"
                style={{
                  backgroundImage: 'url(https://readdy.ai/api/search-image?query=Fashion%20quality%20control%20inspection%20scene%20hands%20holding%20beige%20fabric%20garment%20examining%20stitching%20detail%20with%20measurement%20tape%20on%20light%20oak%20desk%20natural%20window%20light%20soft%20shadows%20clean%20editorial%20photography%20warm%20neutral%20tones%20professional%20minimal%20aesthetic&width=600&height=750&seq=about-qc-2026&orientation=portrait)',
                }}
              />
              <div
                className="flex-1 aspect-[4/5] rounded-2xl bg-cover bg-center"
                style={{
                  backgroundImage: 'url(https://readdy.ai/api/search-image?query=Bright%20airy%20modern%20warehouse%20interior%20with%20neatly%20stacked%20fashion%20boxes%20on%20industrial%20shelving%20units%20natural%20sunlight%20streaming%20through%20large%20windows%20organized%20clean%20workspace%20minimal%20aesthetic%20warm%20industrial%20tones%20professional%20logistical%20environment&width=900&height=750&seq=about-warehouse-2026&orientation=portrait)',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}